import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useSectionId } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useCallback, useMemo, useState } from 'react'
import useRepeatableMetaData from '@v4/hooks/useRepeatableMetaData'
import useStyles from './Video8.styled'

export const useVideo8 = props => {
	const { metaData } = props
	const sectionId = useSectionId()
	const classes = useStyles(props)

	const [activeItemKey, setActiveItemKey] = useState(null)

	const group = 'items'

	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group,
	})

	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })
	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})

	const activeItemIndex = useMemo(() => {
		const index = _.findIndex(items, item => item === activeItemKey)

		return index !== -1 ? index : 0
	}, [activeItemKey, items])

	const itemMetaData = useRepeatableMetaData({ group, index: activeItemIndex })

	const handleVideoClick = useCallback(itemKey => {
		setActiveItemKey(itemKey)
	}, [])

	const handleToggleModal = useCallback(() => {
		setActiveItemKey(null)
	}, [])

	return [
		{
			classes,
			items,
			open: !!activeItemKey,
			video: itemMetaData.itemVideo,
			mobileAlignment: metaData.mobileAlignment?.metaValue,

			title: metaData.title?.metaValue,
			titleConfig: metaData.title?.config,
			titleKey: metaData.title?.tierKey,
			titleEditable,
		},
		{ handleTitleClick, handleTitleChange, handleToggleModal, handleVideoClick },
	]
}
